import {
  Box,
  Button,
  Grid,
  InputAdornment,
  Modal,
  Typography,
} from "@mui/material";
import { Formik } from "formik";
import React, { useState } from "react";
import { useQueryClient } from "react-query";
import { object, string } from "yup";
import { BANKLIST } from "../../config/cacheKey";
import { BankResponse, IbanRequest } from "../../models/iban.model";
import MaterialTextFieldComponent from "../textField/MaterialTextFieldCmp";

const deactiveUserStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  minWidth: {
    xs: 250,
    sm: 300,
    md: 400,
  },
  maxWidth: {
    xs: 250,
    sm: 300,
    md: 400,
  },

  maxHeight: "70vh",
  minHeight: "30vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  // overflow: "auto",
  // overflowX: "hidden",
  // paddingRight: "3vh",
  paddingTop: "4vh",
  // direction: "ltr",
  borderRadius: "5px",
  "&::-webkit-scrollbar": {
    width: 7,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F9FAFC",
    border: "2px solid #DAE0E4",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9AAFC4",
  },
};
const ibanValidation = object().shape({
  owner: string()
    .ensure()
    .required("لطفا نام صاحب حساب را وارد نمایید.")
    .max(300, "نام صاحب حساب نباید بیش از 300 کاراکتر باشد"),
  iban: string()
    .ensure()
    .required("لطفا شماره شبا را وارد نمایید.")
    .min(24, "شماره شبا باید 26 کاراکتر داشته باشد"),
});
interface Props {
  openAddIbanModal: boolean;
  setOpenAddIbanModal: (open: boolean) => void;
  handleAdd: Function;
}
const ModalAddIban = ({
  openAddIbanModal,
  setOpenAddIbanModal,
  handleAdd,
}: Props) => {
  const initialValues: IbanRequest = {
    iban: "",
    owner: "",
  };
  const [bankResponse, setBankResponse] = useState<BankResponse>();
  const queryClient = useQueryClient();
  const [bankPrefix, setBankPrefix] = useState<number>(0);
  const banks = queryClient.getQueryData<BankResponse[]>(BANKLIST) || [];

  const handleFormSubmit = (values: IbanRequest) => {
    handleAdd(values);
  };
  const handleFindBank = (e: any) => {
    if (
      // e.target.value.length > 4 &&
      e.target.value.substring(2, 5) !== bankPrefix
    ) {
      setBankResponse(
        banks.find((f) => f.prefix === e.target.value.substring(2, 5))
      );
      setBankPrefix(e.target.value.substring(2, 5));
    }
  };
  return (
    <>
      <Modal
        open={openAddIbanModal}
        onClose={() => {
          setOpenAddIbanModal(false);
          setBankResponse(undefined);
          setBankPrefix(0);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={deactiveUserStyle}>
          <Grid
            container
            flexDirection={"column"}
            justifyContent={"space-between"}
            alignItems={"center"}
            gap={"2rem"}
          >
            <Grid item>
              <Typography
                component={"p"}
                display={"block"}
                textAlign={"center"}
                color={"#1D4A87"}
                fontSize={"18px"}
                fontWeight={"bold"}
                // marginY={"3rem"}
                // fontSize={"44px"}
              >
                افزودن شماره شبا جدید
              </Typography>
            </Grid>
            <Formik
              initialValues={initialValues}
              onSubmit={handleFormSubmit}
              validationSchema={ibanValidation}
            >
              {({
                handleSubmit,
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
              }) => (
                <Grid item sx={{ width: "100%" }}>
                  <form onSubmit={handleSubmit}>
                    <Grid
                      container
                      gap={"2rem"}
                      justifyContent={"center"}
                      alignItems={"center"}
                    >
                      <Grid item xs={12}>
                        <MaterialTextFieldComponent
                          // sx={{ maxWidth: "400px" }}
                          placeHolder={"نام صاحب حساب"}
                          label={"نام صاحب حساب"}
                          required={true}
                          name="owner"
                          id="owner"
                          helperText={touched.owner ? errors.owner : ""}
                          error={touched.owner && Boolean(errors.owner)}
                          onChange={handleChange}
                          value={values.owner}
                          onBlur={handleBlur}
                        />
                      </Grid>

                      <Grid item xs={12} sx={{ display: "flex" }}>
                        <Grid width={"100%"} item>
                          <MaterialTextFieldComponent
                            className="shebaInput"
                            placeHolder={"شماره شبا"}
                            label={"شماره شبا"}
                            name="iban"
                            id="iban"
                            required={true}
                            helperText={touched.iban ? errors.iban : ""}
                            error={touched.iban && Boolean(errors.iban)}
                            onChange={(e: any) => {
                              handleChange(e);
                              handleFindBank(e);
                            }}
                            value={values.iban}
                            onBlur={handleBlur}
                            onKeyDown={(e) => {
                              if (/^(?![0-9]).*$/.test(e.key)) {
                                if (e.code !== "Backspace")
                                  if (e.code !== "Delete") e.preventDefault();
                              }
                            }}
                            inputProps={{ maxLength: 24 }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment
                                  position="end"
                                  sx={{
                                    width: "50px",
                                    height: "40px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    borderLeft: "1px solid #1D4A87",
                                    backgroundColor: "#F9FAFC",
                                    maxHeight: "unset",
                                  }}
                                >
                                  <Box>
                                    <Typography
                                      sx={{
                                        color: "#1D4A87",
                                        fontSize: "1rem",
                                        fontWeight: "600",
                                      }}
                                    >
                                      IR
                                    </Typography>
                                  </Box>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Grid>
                      </Grid>
                      <Grid item xs={12}>
                        {bankResponse && (
                          <Box
                            sx={{
                              backgroundColor: "#F9FAFC",
                              border: "1px solid #DAE0E4",
                              borderRadius: "5px",
                              position: "relative",
                              height: "50px",
                              display: "flex",
                              alignItems: "center",
                              paddingInline: "15px",
                            }}
                          >
                            <Typography
                              sx={{
                                color: "#043D5D",
                                fontSize: "0.875rem",
                                fontWeight: "bold",
                                position: "absolute",
                                top: "-10px",
                                right: "15px",
                                width: "fit-content",
                                paddingInline: "3px",
                              }}
                            >
                              بانک متصل
                            </Typography>
                            <Typography
                              sx={{
                                color: "#757575",
                                fontSize: "1rem",
                                fontWeight: "600",
                                display: "flex",
                                justifyContent: "start",
                                alignItems: "center",
                                gap: "12px",
                              }}
                            >
                              <Box sx={{ height: "30px", width: "30px" }}>
                                <img
                                  src={`/images/Banks/${bankResponse?.prefix}.png`}
                                  alt={bankResponse?.title}
                                  style={{
                                    width: "100%",
                                    height: "auto",
                                    objectFit: "cover",
                                  }}
                                />
                              </Box>
                              {bankResponse?.title}
                            </Typography>
                          </Box>
                        )}
                      </Grid>

                      <Grid item width={"100%"}>
                        <Grid
                          container
                          flexDirection={"row"}
                          justifyContent={"center"}
                          gap={"1rem"}
                        >
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            lg={6}
                            maxWidth={"150px !important"}
                          >
                            <Button
                              fullWidth
                              variant="contained"
                              type="submit"
                              disabled={
                                !values.iban ||
                                !values.owner ||
                                values.iban.length !== 24 ||
                                bankResponse === undefined
                              }
                              className={
                                !values.iban ||
                                !values.owner ||
                                values.iban.length !== 24 ||
                                bankResponse === undefined
                                  ? "btnForm disabledBtn"
                                  : "btnForm SuccessDefault"
                              }
                            >
                              ثبت
                            </Button>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            lg={6}
                            maxWidth={"150px !important"}
                          >
                            <Button
                              fullWidth
                              variant="contained"
                              style={{
                                fontSize: "1rem",
                                color: "#fff",
                                height: "40px",
                                background: "#607D8B",
                              }}
                              onClick={() => {
                                setOpenAddIbanModal(false);
                                setBankResponse(undefined);
                                setBankPrefix(0);
                              }}
                            >
                              انصراف
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </form>
                </Grid>
              )}
            </Formik>
          </Grid>
        </Box>
      </Modal>
    </>
  );
};

export default ModalAddIban;
